import React, { Component } from "react";
import PropTypes from "prop-types";
import { Menu, Item } from "@zendeskgarden/react-menus";
import { showDuplicateRoute } from "utils/navigation";
import t from "@zendesk/client-i18n-tools";
import DeleteVerificationRuleMutation from "components/DeleteVerificationRuleMutation";
import UpdateVerificationRuleMutation from "components/UpdateVerificationRuleMutation";
import ModalDialog from "@zendesk/knowledge-components/lib/ModalDialog";
import styles from "./styles.css";

import {
  ButtonGroupView,
  Button,
  ChevronButton,
} from "@zendeskgarden/react-buttons";

export default class EditSplitButton extends Component {
  static Item = Item;

  static propTypes = {
    id: PropTypes.string.isRequired,
  };

  state = {
    isOpen: false,
    showDeleteConfirmation: false,
  };
  showDuplicateRoute = ruleId => showDuplicateRoute(ruleId);

  onStateChange = newState => this.setState(newState);

  showDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: true });

  hideDeleteConfirmation = () =>
    this.setState({ showDeleteConfirmation: false });

  render() {
    const { id } = this.props;
    const { isOpen, showDeleteConfirmation } = this.state;

    return (
      <React.Fragment>
        <UpdateVerificationRuleMutation id={id}>
          {updateVerification => (
            <ButtonGroupView>
              <Button
                data-test-id="save-verification-rule"
                size="small"
                primary
                onClick={updateVerification}
              >
                {t("knowledge-verification.save")}
              </Button>
              <Menu
                isOpen={isOpen}
                placement="top-end"
                onChange={selectedKey => {
                  switch (selectedKey) {
                    case "save":
                      return updateVerification();
                    case "duplicate":
                      return this.showDuplicateRoute(id);
                    case "delete":
                      return this.showDeleteConfirmation();
                  }
                }}
                onStateChange={this.onStateChange}
                trigger={({ ref }) => (
                  <ChevronButton
                    data-test-id="edit-menu-trigger"
                    size="small"
                    primary
                    buttonRef={ref}
                    rotated={isOpen}
                    active={isOpen}
                    aria-label="Other Options"
                  />
                )}
              >
                <Item key="save" data-test-id="save-verification-rule">
                  {t("knowledge-verification.save")}
                </Item>
                <Item
                  key="duplicate"
                  data-test-id="duplicate-verification-rule"
                >
                  {t("knowledge-verification.duplicate")}
                </Item>
                <Item key="delete" data-test-id="delete-verification-rule">
                  <span className={styles.deleteItem}>
                    {t("knowledge-verification.delete")}
                  </span>
                </Item>
              </Menu>
            </ButtonGroupView>
          )}
        </UpdateVerificationRuleMutation>
        {showDeleteConfirmation && (
          <DeleteVerificationRuleMutation id={id}>
            {deleteVerification => (
              <ModalDialog
                testId="deleteConfirmationModal"
                visible
                danger
                body={t("knowledge-verification.deleteRuleConfirmation")}
                onSubmit={deleteVerification}
                onCancel={this.hideDeleteConfirmation}
              />
            )}
          </DeleteVerificationRuleMutation>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditSplitButton/index.js